import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBsPwg_3m_qwuQR5zbIUWMC8sn3owKkkAE",
  authDomain: "pretplata-f2541.firebaseapp.com",
  projectId: "pretplata-f2541",
  storageBucket: "pretplata-f2541.firebasestorage.app",
  messagingSenderId: "820439771780",
  appId: "1:820439771780:web:403d7e2796d3425621b0d1",
  measurementId: "G-ENC3BCGD9N"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
